const lenis = new Lenis();

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

window.addEventListener("load", () => {
  ScrollTrigger.refresh();

  if (typeof lenis !== "undefined" && lenis.update) {
    lenis.update();
  }
});

// in-view detect
!(function () {
  const blocks = document.querySelectorAll("h2, .subtitle, .fade-in, .fade-in-wrapper > *");

  [].forEach.call(blocks, ($item) => {
    function onScroll() {
      let delta = $item.getBoundingClientRect().top - window.innerHeight <= ($item.offsetHeight * -1) / 4 && !$item.classList.contains("in-view");

      if (delta) {
        setTimeout(() => {
          $item.classList.add("in-view");
        }, 200);
      }
    }
    onScroll();

    lenis.on("scroll", (e) => {
      onScroll();
    });
  });
})();

// Scrollbar width
function getScrollbarWidth() {
  const div = document.createElement("div");
  div.style.width = "100px";
  div.style.height = "100px";
  div.style.overflow = "scroll";
  div.style.position = "absolute";
  div.style.top = "-9999px";

  document.body.appendChild(div);

  const scrollbarWidth = div.offsetWidth - div.clientWidth;

  document.body.removeChild(div);

  return scrollbarWidth;
}

//headroom
var header = document.querySelector(".header");

function getOffsetValue() {
  var headerHeight = document.querySelector(".header").clientHeight;

  return {
    up: 0,
    down: headerHeight,
  };
}

var headroom = new Headroom(header, {
  offset: getOffsetValue(),
});

headroom.init = function () {
  this.offset = getOffsetValue();

  window.addEventListener(
    "resize",
    () => {
      if (!this.initialised) {
        return;
      }

      this.initialised = false;
      this.scrollTracker.destroy();
      this.init();
    },
    {
      once: true,
    }
  );

  return Headroom.prototype.init.apply(this, arguments);
};
headroom.init();

function setInitialViewportHeight() {
  const vh = window.innerHeight;
  document.body.style.setProperty("--real-vh", `${vh}px`);
}

window.addEventListener("load", () => {
  const tl = gsap.timeline({
    delay: 0.5,
    onComplete: function () {
      setInitialViewportHeight();
    },
  });

  tl.to(".preloader", {
    duration: 1,
    scaleY: 0,
    ease: "power4.inOut",
  })
    .to(
      ".s-hero",
      {
        y: 0,
        duration: 0.9,
        ease: "power4.out",
      },
      "-=1"
    )
    .to(".header", {
      opacity: 1,
      duration: 0.3,
      ease: "none",
    })
    .call(
      () => {
        document.querySelector(".s-hero h1").classList.add("in-view");
        document.querySelector(".s-hero p").classList.add("in-view");
      },
      null,
      "-=0.2"
    );

  tl.set(".preloader", { display: "none" });
});

document.addEventListener("DOMContentLoaded", () => {
  // parallax
  let parallaxAmount = window.innerHeight * 0.01;
  if (window.innerWidth < 1024) {
    parallaxAmount = window.innerHeight * 0.005;
  }
  document.querySelectorAll(".img-parallax img").forEach((img) => {
    gsap.set(img, {
      y: -parallaxAmount,
    });
    gsap.to(img, {
      y: parallaxAmount,
      scrollTrigger: {
        trigger: img,
        start: "top bottom",
        end: "bottom top",
        scrub: 1,
      },
    });
  });

  gsap.to(".s-hero", {
    yPercent: -40,
    ease: "none",
    scrollTrigger: {
      trigger: ".intersect",
      start: "top top",
      end: () => "+=" + window.innerHeight,
      scrub: true,
    },
  });

  // header theme
  document.querySelectorAll("[data-header]").forEach((section) => {
    const headerTheme = section.getAttribute("data-header");

    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: () => "+=" + section.clientHeight,
      onEnter: () => {
        if (headerTheme === "dark") {
          document.querySelector(".header").classList.add("theme-dark");
        } else {
          document.querySelector(".header").classList.remove("theme-dark");
        }
      },
      onEnterBack: () => {
        if (headerTheme === "dark") {
          document.querySelector(".header").classList.add("theme-dark");
        } else {
          document.querySelector(".header").classList.remove("theme-dark");
        }
      },
    });
  });
});

CustomEase.create("de-ease", "0.625, 0.05, 0, 1");

const headlines = document.querySelectorAll("h1, h2");
let splits = [];

function splitHeadlines() {
  splits.forEach((split) => split.split({ reset: true }));
  splits = [];

  headlines.forEach((headline) => {
    const headlineSplit = SplitType.create(headline, {
      types: "lines, words, chars",
    });

    headline.style.visibility = "visible";
    splits.push(headlineSplit);
  });
}

splitHeadlines();

let lastWidth = window.innerWidth;
let resizeTimer;

window.addEventListener("resize", () => {
  if (window.innerWidth === lastWidth) return;
  lastWidth = window.innerWidth;

  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    splitHeadlines();
    ScrollTrigger.refresh();
  }, 200);
});

jQuery(document).ready(function ($) {
  // menu
  function navOpen() {
    $(".navbar-toggler").addClass("active");
    $(".header").addClass("nav-opened");
    $(".header-menu").addClass("active");
  }
  function navClose() {
    $(".navbar-toggler").removeClass("active");
    setTimeout(() => {
      $(".header").removeClass("nav-opened");
    }, 300);
    $(".header-menu").removeClass("active");
  }
  $(".header .navbar-toggler").on("click", function () {
    $(this).hasClass("active") ? navClose() : navOpen();
  });

  // navigation waypoints
  $(".section").waypoint(
    function (direction) {
      if (!this.element.id) return;
      if (direction === "down") {
        $(".navigation-main .active").removeClass("active");
        var selector = ".navigation-main a[href='#" + this.element.id + "']";
        $(selector).parent().addClass("active");
      }
    },
    {
      offset: 0,
    }
  );
  $(".section").waypoint(
    function (direction) {
      if (!this.element.id) return;
      if (direction === "up") {
        $(".navigation-main .active").removeClass("active");
        var selector = ".navigation-main a[href='#" + this.element.id + "']";
        $(selector).parent().addClass("active");
      }
    },
    {
      offset: -100,
    }
  );

  function smoothAnchor(e) {
    if ($(".header-menu").hasClass("active")) {
      navClose();
    }

    const target = this.hash;
    console.log(target);
    if (!target || target === "#") return;

    e.preventDefault();
    const dest = document.querySelector(target);
    if (dest) lenis.scrollTo(dest, { duration: 1 });
  }

  $(".header-menu-main a").on("click", smoothAnchor);
  $(".footer-menu a").on("click", smoothAnchor);
  $(".btn-anchor").on("click", smoothAnchor);

  // hero slider
  $(".slider-hero").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    dots: false,
    speed: 1200,
    pauseOnHover: false,
    pauseOnFocus: false,
    cssEase: "linear",
  });

  // project slider
  const $projectSlider = $("#sliderProjects");

  $projectSlider.on("init", function () {
    ScrollTrigger.refresh();
  });

  $projectSlider.slick({
    centerMode: true,
    centerPadding: "351px",
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    prevArrow: $(".projects-prev"),
    nextArrow: $(".projects-next"),
    dots: false,

    responsive: [
      {
        breakpoint: 1800,
        settings: {
          variableWidth: false,
          centerMode: true,
          centerPadding: "18.23vw",
        },
      },
      {
        breakpoint: 768,
        settings: {
          variableWidth: true,
          centerMode: false,
          centerPadding: 0,
        },
      },
    ],
  });

  // accordion
  $(".accordion-button").on("click", function () {
    if ($(window).width() >= 1024) {
      return;
    }
    const $item = $(this).closest(".accordion-item");
    const $body = $item.find(".accordion-body");

    if ($body.is(":visible")) {
      $body.slideUp(200);
      $item.removeClass("active");
    } else {
      $(".accordion-body").slideUp(200);
      $(".accordion-item").removeClass("active");
      $body.slideDown(200);
      $item.addClass("active");
    }
  });

  // modal
  const $modal = $(".modal");
  const $modalImage = $(".modal-image");
  const $modalContent = $(".modal-content");

  $(".trigger-modal").on("click", function (e) {
    if (e.target.tagName == "svg" || e.target.tagName == "path" || e.target.tagName == "A") {
      return;
    }
    const $card = $(this).closest(".card-team");
    const cardImage = $card.find(".card-image").html();
    const innerHtml = $card.find(".card-modal-content").html();
    $modalImage.html(cardImage);
    $modalContent.html(innerHtml);
    $modal.addClass("open");
    $("body").css({ height: "100%", overflow: "hidden", "padding-right": getScrollbarWidth() });
    // const scrollY = $(window).scrollTop();
    // $("body").css({ position: "fixed", top: -scrollY });
    // headroom.freeze();
  });

  function closeModal() {
    $("body").removeAttr("style");
    // const scrollY = document.body.style.top;
    // $("body").css({ position: "initial", top: 0 });
    // window.scrollTo(0, parseInt(scrollY || "0") * -1);
    // headroom.unfreeze();
    $(".modal").removeClass("open");
    setTimeout(() => {
      $(".modal-image").html("");
      $(".modal-content").html("");
    }, 300);
  }

  $(".modal-close, .modal-bg").on("click", closeModal);
});
